import { useState, useEffect, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";

import TableGrid from '@/components/TableGrid';

import Input from '@/components/Input';
import Button from '@/components/Button';

const ItemModal = lazy(() => import('/src/modals/ItemModal'));
const ConfigModal = lazy(() => import('/src/modals/ConfigModal'));
const InformationModal = lazy(() => import('/src/modals/InformationModal'));

//import {getIconButtonStyle} from '@/utils/Styles';
//import IconButton from '@mui/material/IconButton';
import { 
	/*Add as AddIcon, 
	Create as EditIcon, 
	Save as SaveIcon, 
	Delete as RemoveIcon,
	GetApp as ExportIcon,
	PictureAsPdf as PDFIcon,
	TableRows as CSVIcon,
	TableRows as ExcelIcon,
	Settings as ConfigIcon,
	Print as PrintIcon,
	Share as ShareIcon,*/
	FilterAlt as FilterIcon,
	FilterAltOff as FilterOffIcon
} from '@mui/icons-material';

import { exportData } from '@/utils/Export';

import { 
	replaceIfItemView, 
	getNeedsSelection, 
	buildSelectionInfo, 
	getNodes, 
	getTableParam, 
	getNodeNewValues,
	setTableParam,
	removeTableParam,
	getTableConfig,
	setTableConfig,
	removeTableConfig,
	checkTableConfig
} from '@/utils/Table';

import { getDefaultValue, getEditableColumn } from '@/utils/Columns';
import { getParameterURL, addParameterURL }  from '@/utils/URL';
//import { checkFullPage }  from '@/utils/Settings';

import { checkRender, renderAlert } from "@/utils/Render";

import TableButtons from "@/components/TableButtons";
import { html as htmlFormat } from '@/utils/Format';
import { setParam } from '@/utils/Cookies';

import { checkErrors } from "@/utils/Errors.jsx";

const BooleanModal = lazy(() => import('/src/modals/BooleanModal'));

import EditionModal from '@/modals/EditionModal';

// to open a url on a modal
//import Modal from 'react-modal';
// this id '#root' must be the same on the index
//Modal.setAppElement('#root');

export default function Table({	
	api,setApi,apiUrl,token,handleLogin,
	t,language,user,router,loading,table,config,
	rows,columns,response,/*options,*/sendMessage,
	handleEdit,handleDelete,handleRefresh,modal = true,editable = true,
	handleItemViewAction,enableAdd,enableEdit,enableDelete,
	rowsData,fullScreen,fullPage,setFullPage,openUrlModal
}){

	//const [ api, setApi ] = useState(null);

	const [ root, setRoot ] = useState(null);

	// to show buttons or not depending on the rendered nodes
	// cannot use api?.getRenderedNodes() because if changing pagination it does not change
	const [ numRenderedNodes, setNumRenderedNodes ] = useState(null);

	//var sxIconButton = getIconButtonStyle();
	
	// modal to show an item from the table
	const [ showItem, setShowItem ] = useState(false);	
	const [ item, setItem ] = useState(null);
	const [ itemAction, setItemAction ] = useState(null);
	const [ itemAPI, setItemAPI ] = useState(null);

	// modal to config the table
	const [ showConfig, setShowConfig ] = useState(false);

	// if modal always enabled
    const [ editDisabled, setEditDisabled ] = useState(true);
    const [ deleteDisabled, setDeleteDisabled ] = useState(true);
    const [ savedEnabled, setSavedEnabled ] = useState(false);
    const [ addDisabled, setAddDisabled ] = useState(false);
    const [ shareDisabled, setShareDisabled ] = useState(true);

    const [ searchText, setSearchText ] = useState('');

    // when a filter is applied
	const [ filtersApplied, setFiltersApplied ] = useState(false);

	const [ firstColumnEditable, setFirstColumnEditable ] = useState(null);

	const [ render, setRender ] = useState(null);

	// header fixed
	const [ headerFixed ] = useState(checkTableConfig(user,table,config,'headerFixed'));

	// to handle dropdowns fields on the tables
    // to handle the click on the dropdown multiple chip
    const [ showEdition, setShowEdition ] = useState(false);    
    const [ editionOptions, setEditionOptions ] = useState([]);
    const [ editionColumn, setEditionColumn ] = useState(null);
    const [ editionParams, setEditionParams ] = useState(null);

    // what to do when clicking on the table on any value that cannot be edited inline
    const handleEdition = (params,column,options = null) => {    
        setEditionColumn(column);
        setEditionParams(params);        
        setEditionOptions(options);
        setShowEdition(true);
    }

    // what to do when edition modal updated
    const handleEditionUpdate = (e,column,values) => {        
        
        /*
        const config = {
            headers: { Authorization: `Bearer ${token}` } 
        };

        const data = {
            id: paramsDropdown?.data?.id,            
        };

        // not necessary because it won't save on the database if any change
        // will wait until you send the entire row        
        if(type && type === 'multiple'){

            data[column] = values;

            const send = {
                companyuser: user?.company,
                data: data
            };

            var errorMessage = t('actions.edit.error');

            var endpoint = apiUrl;
            switch(table){
                
                case 'notifications':
                    endpoint += '/notification/edit';
                    break;
                
                case 'employees':
                    endpoint += '/employee/edit';
                    break;
                
                default:
                    endpoint += '/'+table+'/edit';
                    break;
            }
            
            axios.put(endpoint,send,config)
            .then(function (response) {
                
                if(response?.data){
              
                    var dataResult = response.data;

                    // if result is ok (1)
                    if(dataResult?.result){                    
                        //sendMessage(t('actions.edit.success'),'success');

                        // if saved, update the grid
                        //const api = paramsDropdown?.api;
                        const node = paramsDropdown?.node;
                        node?.setDataValue(column,data[column]);
                        setShowDropdown(false);
                    } 
                    else{

                        if(dataResult?.status && dataResult.status === 401){
                            handleLogin();
                        }
                        else{                        
                            if(dataResult?.data?.reasons){
                                const reasons = dataResult?.data?.reasons;
                                var message = t('error.list')+'\n\n';

                                Object.keys(reasons)?.map((field) => {
                                    message += '- '+t(table+'.errors.'+reasons[field])+'\n';
                                });
                                errorMessage = message;
                                
                            }
                            
                            sendMessage(errorMessage,'error');
                        }
                    }
                }
                else{
                    sendMessage(errorMessage,'error');
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();
                }
                else{
                    sendMessage(errorMessage,'error');
                }
            });
        }
        */

        const apiTable = editionParams?.api;
        var nodeTable = editionParams?.node;
        const rowIndex = nodeTable?.rowIndex;

        // set the new value on the row        
        nodeTable?.setDataValue(column,values);

        // get the closest editable column to the current one
        const columnEditable = getEditableColumn(apiTable,column);

        // known issue. without timeout it does not start editing the row                
        setTimeout(() => {        

            // flag updated to false because we don't want to save the row
            // and if we use startEditingCell, it executes stopEditing first
            // so it would be saved
            nodeTable.updated = false;

            // hide modal
            setShowEdition(false); 
                              
            apiTable?.startEditingCell({
                rowIndex: rowIndex,
                colKey: columnEditable
            });

            // select and focus on the row                  
            nodeTable.setSelected(true);  

            apiTable?.setFocusedCell({
                rowIndex: rowIndex,
                colKey: columnEditable
            });

        },0); 
    }

    // what to do when clicking on the button to select an item
    // if admin is true, remove button was clicked
	const handleTableItemSelected = (apiTable, admin = false) => {

		/*
	    var split = path.split('/');
	    var parent = split[1];
	    */
	    var parent = getNeedsSelection(router.pathname,table);
	    
	    // if on parent menu, check if any option selected and save it
	    let message;
	    let renderTableInfo;
	    if(parent === table){

	    	// remove item
			if(admin){
				
				removeTableParam(user,parent,'selected'); 
				
				// check if any extra render depending on the table 
            	message = t('actions.select.text',{table:t(parent+'.menu.title')});
                renderTableInfo = renderAlert(user,apiTable,'error',message,t('actions.select.button'),handleTableItemSelected);                
                setRender(renderTableInfo); 
			}
			else{
		        const selectedNodes = apiTable.getSelectedNodes();
		    
		        if(selectedNodes && selectedNodes.length > 0){

		            if(selectedNodes.length === 1){

		            	const node = selectedNodes[0];
		            	const itemInfo = buildSelectionInfo(parent,node?.data,columns);
		                
		                setTableParam(user,parent,'selected',itemInfo);                    
		                
		                message = t('actions.selected.text',{table:t(parent+'.menu.title'),item:itemInfo?.name+itemInfo?.nameappend});
		                sendMessage(message);
		                
		                //if(router.pathname === '/'+parent){
		                //    message = message+'. '+t('actions.selected.subtext');
		                //}                    

		                // if root, show button to remove selected
        				const adminButton = user?.roles_tags?.includes('root');
        				const adminButtonText = adminButton ? t('actions.remove.button') : null;
		                renderTableInfo = renderAlert(user,apiTable,'success',message,t('actions.change.button'),handleTableItemSelected,adminButtonText);                
		                setRender(renderTableInfo);
		            }
		            else{
		                sendMessage(t('actions.select.multiple'),'error');
		            }
		        }
		        else{
		            sendMessage(t('actions.select.empty',{item:t(parent+'.menu.title')}),'error');
		        }
		    }
	    }
	    else{
	        // if submenu, button goes to parent menu           
	        router.navigate('/'+parent);
	    }
	};

	// on row selected, do actions
	const onRowSelected = (apiTable) => {

		// change message above the table if on parent menu and some row selected
		// instead of change, use accept/ok
		// if parent menu and option selected and row clicked, change message on the button
		const needsSelection = getNeedsSelection(router.pathname,table);
		const selectionInfo = getTableParam(user,needsSelection,'selected');			
		const rows = getNodes(apiTable);
		
		if(selectionInfo?.id && needsSelection === table && rows && rows?.length > 1){		    
		    
		    const selected = apiTable?.getSelectedNodes();
		    let buttonText;
		    let text;
		    let type;
		    if(selected && selected?.length === 1){
		    	const newSelectionInfo = buildSelectionInfo(table,selected[0]?.data,columns);
		    	text = t('actions.acceptselection.text',{item:newSelectionInfo?.name+newSelectionInfo?.nameappend});
		    	buttonText = (t('actions.acceptselection.button'));
		    	type = 'error';
		    }
		    else{
		    	text = t('actions.selected.text',{table:t(table+'.menu.title'),item:selectionInfo?.name+selectionInfo?.nameappend});
		    	buttonText = (t('actions.change.button'));
		    	type = 'success';
		    }
		    
		    // if root, show button to remove selected if some item selected
		    const admin = user?.roles_tags?.includes('root');
		    const adminButtonText = admin ? t('actions.remove.button') : null;     

		    const newRender = renderAlert(user,apiTable,type,text,buttonText,handleTableItemSelected,adminButtonText);  		    
		    setRender(newRender);
		}

	}

	// to render the table
	const renderTable = () => {
		
		// apply pagination items per page
		var paginationPageSize = getTableConfig(user,table,'paginationPageSize');
		// default value
    	if(!paginationPageSize){					
			paginationPageSize = 20;
		}

		let rootElement;
		if(!root){
			rootElement = createRoot(document.getElementById("table-grid"));
			setRoot(rootElement);
		}
		else{
			rootElement = root;
		}

		rootElement.render(
    		<TableGrid
          		t={t}     
          		language={language}
          		user={user}     		
          		api={api}
          		setApi={setApi}
          		router={router}
          		table={table}
          		config={config}
          		editable={editable}
          		modal={modal}
	    		loading={loading}
	    		columns={columns}
	            rows={rows}	            	            
	            handleButtonView={handleButtonView}
	            handleButtonAdd={handleButtonAdd}
	            handleButtonEdit={handleButtonEdit}
	            handleButtonDelete={handleButtonDelete}
	            handleButtonShare={handleButtonShare}
	            setEditDisabled={setEditDisabled}	 
	            setSavedEnabled={setSavedEnabled}     
	            setDeleteDisabled={setDeleteDisabled}
	            setAddDisabled={setAddDisabled}
	            setShareDisabled={setShareDisabled}
	            setFiltersApplied={setFiltersApplied}     
	            handleSearchClear={handleSearchClear}			            
	            paginationPageSize={paginationPageSize}       
	            enableAdd={enableAdd}
	            enableEdit={enableEdit}
	            enableDelete={enableDelete}
	            openUrlModal={openUrlModal}
	            onRowSelected={onRowSelected}
	            setNumRenderedNodes={setNumRenderedNodes}
	            handleEdit={handleEdit}
	            setRender={setRender}	              
	            sendMessage={sendMessage}  
	            headerFixed={headerFixed}     
	            handleEdition={handleEdition}   
	            //autoSizeStrategy={config?.fit ? 'fitGridWidth' : 'fitCellContents'} //fitGridWidth,fitCellContents
	            //gridOptions.api.setGridOption('autoSizeStrategy', newStrategy);
	        />	
        );
	}

	// by default 20 items per page
	//const [ paginationPageSize, setPaginationPageSize ] = useState(20);

	useEffect(() => {
    	if(table){
    		renderTable();        	
		}
    }, [table]);

    // detect change on table and api
	// table will change for every table
	// api will only change when loaded for the first table. after that every table change if it is GenericTable
	// it won't change the api
    useEffect(() => {    	

    	if(api){

    		// doing here to re-create the grid for every table because we re-use the Table component
    		// so the AGGrid does not refresh config and columns are not properly resized, etc.
    		//if(!api){
    		//	renderTable();
        	//}
        	//else{

        		setNumRenderedNodes(api?.getRenderedNodes()?.length);

		    	// if coming from editing data update the nodes
		    	// for example on tickets, you can edit the ticket on the ticket details
		    	// so when going back, update the table
		    	if(rowsData !== null && rowsData?.length > 0){
		    		
		    		// "id" field must be the same to find the rows		    		
		    		api?.applyTransaction({
                        "update": rowsData
                    });
		    	}

        		// check if saved search
		    	applyInitialSearch(api);

		    	// check if any extra render depending on the table 
		    	var renderTableInfo = checkRender(t,api,user,router.pathname,table,rows,columns,config,handleTableItemSelected,sendMessage);
		    	setRender(renderTableInfo);
    		
    			// check if creating with &create=1
    			const create = getParameterURL(router,'create');

    			if(create){
    				handleButtonAdd();
    			}
		    //}
		}

    }, [api/*,table,config*/]);

	// using this to hot translate the table if changing language
	/*
    useEffect(() => {

    	// checking if api to avoid re-render the table because the first time we use the useEffect
    	// above to render it
    	if(table && api){
    		renderTable();        	
		}

    }, [t]);
	*/
	
    const handleSearchInput = (e) => {
        
        //var name = e.target.name;
        var value = e.target.value;

        setSearchText(value);
    };

    // add quick search to the url
    const handleURLAddParam = (name,value) => {
		const url = addParameterURL(router.pathname,router.searchParams,name,value);
		router.navigate(url);
		//window.history.pushState({path:url?.href},'',url?.href);
	}

	// make initial search
	const applyInitialSearch = (apiTable) => {
		
		var searchParam = getParameterURL(router,'search');
    	
    	// if receiving search by get parameter
    	if(searchParam){

    		setSearchText(searchParam);
    		apiTable?.setGridOption("quickFilterText",searchParam);

    		// save on config to recover later			
    		setTableConfig(apiTable,user,table,'quickFilterText',searchParam);
    	}
    	else{
    	
    		// check if quick search saved
    		var savedSearch = getTableConfig(user,table,'quickFilterText');
    		if(savedSearch){
    			setSearchText(savedSearch);
    			apiTable?.setGridOption("quickFilterText",savedSearch);
    		}
    		else{
    			// if not, clear search
    			handleSearchClear(apiTable);
    		}
    	}
	}

    const handleSearch = () => {
    	
    	api.setGridOption("quickFilterText",searchText);

    	// save on config to recover later
    	setTableConfig(api,user,table,'quickFilterText',searchText);
    	
    	handleURLAddParam('search',searchText);
    	//setFiltersApplied(true);
    };

    const handleSearchClear = (apiTable) => {    	
    	
    	setSearchText('');
    	//if(!apiTable.isDestroyed()){
    		apiTable.setGridOption("quickFilterText",'');
    	//}
    	handleURLAddParam('search','');

    	// remove saved search
    	removeTableConfig(user,table,'quickFilterText');
    };

    // submit with enter on the searh box
    const handleQuickSearchKeyDown = () => {
		if (event.keyCode === 13) {
			handleSearch();
		}
	}

	// remove filters
	const removeFilters = (/*params*/) => {
		
		//const api = gridRef?.current?.api;

		// clear quick filter
		handleSearchClear(api);

		// clear columns filters
		api?.setFilterModel(null);
		//api.setRowGroupColumns([]);
		//api.onFilterChanged();

		// remove saved filters
		removeTableConfig(user,table,'filterState');

		setFiltersApplied(false);
	}

	// action when clicking on view row button
	const handleButtonView = (params,type = 'row') => {		

		// get the node

		// if coming from action on the row (button on the row or double click)
		let apiTable;
		let node;
		if(type === 'row' || type === 'doubleclick'){			
			apiTable = params?.api;
			node = params?.node;
		}
		else{
			// if generic action (button above the table)
			apiTable = api;

			const selectedNodes = apiTable.getSelectedNodes();
			if(selectedNodes && selectedNodes.length > 0){
				node = selectedNodes[0];
			}
		}
    	
    	// if handleItemViewAction defined, use it
    	if(handleItemViewAction){
    		handleItemViewAction(params);
    	}
    	else{
    		// show item info
	    	if(node){    		
	    		setItemAction('view');
	    		setItem(node);
	    		setItemAPI(apiTable);
				setShowItem(true);
			}
			else{			
				setItemAction(null);
	    		setItem(null);
	    		setItemAPI(null);
				setShowItem(false);
			}
		}
	}

	// https://www.ag-grid.com/react-data-grid/data-update-transactions/
	const handleButtonEdit = (params,type = 'row', action = 'edit') => {

		// if coming from action on the row (button on the row)
		let apiTable;
		let node;
		if(type === 'row'){			
			apiTable = params?.api;
			node = params?.node;
		}
		else{
			// if generic action (button above the table)
			apiTable = api;

			// get the first selected node. anyway the button edit is disabled if more than one selected
			const selectedNodes = apiTable.getSelectedNodes();
			if(selectedNodes && selectedNodes.length > 0){
				node = selectedNodes[0];
			}
		}

		// start editing
		// it only enables to edit the latest selected row
		// so get only the first selected row to edit it
		// get the first selected node. anyway the button edit is disabled if more than one selected	
			
		if(node){
		
			// modal edition
			if(modal){

				// open modal				
				setItemAction('edit');
	    		setItem(node);
	    		setItemAPI(apiTable);
				setShowItem(true);
			}
			else{
				// inline edition
	
				// if saving info with save button or enter key	
				let errorsCheck;
				if(action === 'save' || action === 'enter'){
					
					// stop editing because if not, node.data does not have the new values
					//apiTable.stopEditing();

				    // get updated values
				    // with node.data you get the old ones
				    const data = getNodeNewValues(apiTable,node,columns);
			        
			        // if no cells in edition mode, no error
			        if(data){
						
						// check errors					
						errorsCheck = checkErrors(t,table,apiTable,node,modal,columns,data,sendMessage,action);

			            if(!errorsCheck || Object.keys(errorsCheck).length === 0){
						
							// when stop editing, it saves the values
							apiTable.stopEditing();
							
							// for dropdown it does not detect the change, so cannot use onRowValueChanged
							//handleEdit(action,apiTable,node,data,setSavedEnabled,setAddDisabled,null,setRender,handleTableItemSelected);
						}
					}					
				}
				else{

					// check if we are not already editing the same row		
					// and we click on the pencil on the row
					const cellsEditing = apiTable.getEditingCells();

					const sameRow = cellsEditing.some(cellsEditing => {
			            return cellsEditing.rowIndex === node?.rowIndex;
			        });

					// if different row, save previous one and start edit on new one
				
					// stop editing because if not, node.data does not have the new values		
					//apiTable.stopEditing();	

					// get updated values
				    // with node.data you get the old ones
				    const data = getNodeNewValues(apiTable,node,columns);
			        
			        // if no cells in edition mode, no error
			        if(data){

						// check errors						
						errorsCheck = checkErrors(t,table,apiTable,node,modal,columns,data,sendMessage,'save');

		            	if(!errorsCheck || Object.keys(errorsCheck).length === 0){

		            		// when stop editing, it saves the values
		            		apiTable.stopEditing();

							// for dropdown it does not detect the change, so cannot use onRowValueChanged
							//handleEdit('save',apiTable,node,data,setSavedEnabled,setAddDisabled,null,setRender,handleTableItemSelected);
						}		
					}				
					
					if(!sameRow){

						setTimeout(() => {

				  			apiTable?.startEditingCell({
				    			rowIndex: node?.rowIndex,
				    			colKey: getFirstEditableColumn(apiTable)
				  			});

				  			node.setSelected(true);	

				  		},0);

						setSavedEnabled(true);
						setAddDisabled(true);
					}
				
				}
			}
		}
	}

	const handleButtonDelete = (params,type = 'row') => {

		// if coming from action on the row (button on the row)
		let apiTable;
		if(type === 'row'){			
			apiTable = params?.api;			
		}
		else{
			// if generic action (button above the table)
			apiTable = api;
		}
		
		//const api = gridRef?.current?.api;		
		const selectedRows = apiTable.getSelectedRows();

   		if(selectedRows?.length > 0){   	
   			// show confirmation dialog to delete
   			handleDeleteConfirmationDialog(selectedRows);    		
    	}
    	else{

   			// check if deleting a just added row. if so remove from table but do not call the delete api
   			// because it is not on the database

    		// check if row with index 0 has id null. if so, remove it. it means row added but not saved
    		const nodes = getNodes(apiTable);
    		nodes?.map((node) => {
    			if(node?.rowIndex === 0 && node?.data?.id === null){
    				apiTable?.applyTransaction({
		    			"remove": [node?.data]
					});	
    				return;
    			}
    		});
    	}
	}

	const handleButtonAdd = (e = {},type = 'row') => {

		// avoid eslint error
		if(e && type){

			// if already adding a row
			if(savedEnabled){

				// if add button enabled but not modal, not editable and no edit button
				// it means we are with inline edition and we only have the add button, so cannot use edit button to save
				// so save with add button that changes from Add to Save
				if(!modal && !editable && enableAdd && !enableEdit){
					// simulate edit button when saving
					// params not necessary, using generic api
					handleButtonEdit(null,'general','save');
				}
				else{
					// if not, show a message stating that we cannot add if already adding/editing another row
					// this can only happen if adding element, because when editing add button is disable
					sendMessage(t('actions.add.alreadyediting'),'error');			
				}
			}
			else{
				//const api = gridRef?.current?.api;

				// if modal edition
				if(modal){

					// open modal without values			
					setItemAction('edit');
			    	setItem(null);
			    	setItemAPI(api);
					setShowItem(true);
				}
				else{
					// inline edition

					// in case there is other row selected, unselect it
					api.deselectAll();
					/*
					const selectedNodes = api.getSelectedNodes();
					if(selectedNodes && selectedNodes.length > 0){
						selectedNodes.map((selectedNode) => {
							selectedNode.setSelected(false);
						});
					}
					*/

					// remove filters
					removeFilters();

					const row = {};
					var tableColumns = api.getColumns();
					if(tableColumns?.length > 0){

						tableColumns.map((column) => {

							// by default null value for every field, but check if default value coming from backend
							row[column?.colId] = getDefaultValue(api,table,router,column?.colId,columns[column?.colId]);
						});
										
						var transaction = api?.applyTransaction({
				    		addIndex: 0,
				    		add: [row]
						});				

						var nodes = transaction?.add;
						if(nodes && nodes.length > 0){

							var node = nodes[0];
							var rowIndex = node?.rowIndex;

							// known issue. without timeout it does not start editing the row				
							setTimeout(() => {
														
				      			api?.startEditingCell({
				    				rowIndex: rowIndex,
				    				colKey: getFirstEditableColumn(api)
				  				});

				  				// select and focus on the row	  				
				  				node.setSelected(true);		  				

				    		},0);
						}
					}
				}
			}
		}
	}

	const handleButtonShare = async (params,type = 'row') => {

		// if coming from action on the row (button on the row)
		let apiTable;
		let node;
		if(type === 'row'){			
			apiTable = params?.api;
			node = params?.node;
		}
		else{
			// if item modal, params is the node itself
			if(type === 'modal'){
				node = params;
			}
			else{
				// if generic action (button above the table)
				apiTable = api;

				// get the first selected node. anyway the button is disabled if more than one selected
				const selectedNodes = apiTable.getSelectedNodes();
				if(selectedNodes && selectedNodes.length > 0){
					node = selectedNodes[0];
				}
			}
		}

		// open native share on mobile
		// if not, copy link to clipboard
		if(node){

			const pathFilter = replaceIfItemView(router.pathname);
			
			const link = window.location.protocol+'//'+window.location.host+pathFilter+'/fullview/'+node?.data?.id;

	        // if native sharing (mobile,mac,etc.)
	        if(navigator?.share){
	            
	            try{
	                
	                //const imageSharing = 

	                const shareData = {	                    
	                    title: t(table+'.menu.title'),
	                    //text: t('trans.text'),
	                    url: link
	                };

	                /*
	                if(imageSharing && imageSharing.length > 0){
	                    shareData.image = window.location.protocol+'//'+window.location.host+imageSharing;
	                }

	                if(shareData.image && shareData.image.length > 0){

                        var split = shareData.image.split('/');   
                        var imageName = split.slice(-1);                     
                        let blob = await fetch(shareData.image).then(r => r.blob());
                        var file = new File([blob],imageName, {
                            type: blob.type,
                        });

                        if(navigator.canShare(file)){
                            shareData.files = [file];
                        }
                    }
                    */

                    // even if native sharing, copy as well
		            navigator.clipboard.writeText(link);
		            //sendMessage(t('actions.clipboard.copied'));

                    await navigator.share(shareData);		            
	            }
	            catch(err){
	            	// avoid eslint error

	            	if(err){	            	
	            		//sendMessage('Error','error');
	            	}
	                //onError?.(err);
	                // if user cancels the sharing it goes here as well                
	            }
	        } 
	        else{
	            // if no native sharing, copy to clipboard
	            navigator.clipboard.writeText(link);
	            sendMessage(t('action.clipboard.copied'));
	        }
		}
		else{
			//sendMessage('Error','error');
		}
	}

	// to get the first editable column
	const getFirstEditableColumn = (apiTable) => {

		// check the first cell that is editable if not defined yet
		if(firstColumnEditable === null){
			var columnEditable = getEditableColumn(apiTable);
			setFirstColumnEditable(columnEditable);			
			return columnEditable;
		}
		else{
			return firstColumnEditable;
		}
	}

	// to export
	const [ showExportModal, setShowExportModal ] = useState(false);
	const [ exportType, setExportType ] = useState(null);
	const [ anchorEl, setAnchorEl ] = useState(null);

	// show modal with warning
	const handleButtonExport = (type) => {

		if(type !== 'print'){
			setExportType(type);
			setShowExportModal(true);
		}
		else{
			exportData(type,api,table);
		}
	}

	const handleExportConfirm = () => {		
		setShowExportModal(false);
		exportData(exportType,api,table);
	}

	// to config the table	
	const handleButtonConfig = (/*params*/) => {
		setShowConfig(true);		
	}

	const handleButtonFullscreen = () => {		
		setFullPage(fullPage ? false : true);

		// save on cookies
		setParam('fullPage',fullPage ? 0 : 1);
	}

	// modal to confirm deletion
    const [ showConfirmDelete, setShowConfirmDelete ] = useState(false);
    const [ titleDelete ] = useState(t('actions.delete.title'));
    const [ textDelete ] = useState(t('actions.delete.confirm'));
    const [ deleteSelectedRows, setDeleteSelectedRows] = useState();

    const handleDeleteConfirmationDialog = (selectedRows) => {
    		setDeleteSelectedRows(selectedRows);
        	setShowConfirmDelete(true);
	}

	// used to close modal when deleting if confirmation dialog answer is "yes"
	const handleCloseItemModal = () => {
        setShowItem(false);
    }

    // if confirming deletion
    const handleConfirmDelete = (e,answer) => {

    	// close confirmation modal
        setShowConfirmDelete(false);

        // if yes, delete
        if(answer){        	
            handleDelete(deleteSelectedRows,api,modal ? handleCloseItemModal : null,setRender,handleTableItemSelected);
        }        
    }  

    return (
    	<>
    	<div className='print-only mb-4'>
    		<div dangerouslySetInnerHTML={{__html: htmlFormat(t('legal.policy.print'))}}></div>
    	</div>
    	<EditionModal 
            t={t}
            table={table}
            columns={columns}
            open={showEdition} 
            setOpen={setShowEdition} 
            column={editionColumn}
            params={editionParams}            
            options={editionOptions}
            handleEdition={handleEditionUpdate}
            fullScreen={fullScreen}
        />
    	{
            showExportModal &&
            <Suspense>
                <InformationModal 
                    t={t}
                    open={showExportModal} 
                    setOpen={setShowExportModal}
                    title={t('legal.policy.title')}
                    html={t('legal.policy.export')}
                    action={handleExportConfirm}
                    actionText={t('actions.export.button')}
                    fullScreen={fullScreen}
                />
            </Suspense>
        }
    	{
    		showItem &&
    		<Suspense>
		    	<ItemModal 
		            t={t}
		            open={showItem} 
		            setOpen={setShowItem} 
		            router={router}
		            fields={columns}
		            response={response}
		            //items={rows}
		            action={itemAction}
		            table={table}
		            item={item}
		            api={itemAPI}
		            editable={editable}
		            enableAdd={enableAdd}
		            enableEdit={enableEdit}
		            modal={modal}
		            handleEdit={handleEdit}
		            handleDelete={handleDeleteConfirmationDialog}
		            handleShare={handleButtonShare}
		            getFirstEditableColumn={getFirstEditableColumn}
		            setRender={setRender}
		            handleTableItemSelected={handleTableItemSelected}
		            sendMessage={sendMessage}
		            fullScreen={fullScreen}
		            openUrlModal={openUrlModal}
		        />
		   	</Suspense>
	    }
	    {
    		showConfig &&
    		<Suspense>
		    	<ConfigModal 
		            t={t}
		            open={showConfig} 
		            setOpen={setShowConfig}
		            user={user}
		            api={api}
		            editable={editable}
		            enableAdd={enableAdd}
		            enableEdit={enableEdit}
		            table={table}
		            config={config}
		            columns={columns}
		            modal={modal}
		            headerFixed={headerFixed}
		            sendMessage={sendMessage}
		            fullScreen={fullScreen}
		        />
		   	</Suspense>
	    }
	    {
            showConfirmDelete &&
            <Suspense>
                <BooleanModal                     
                    open={showConfirmDelete} 
                    setOpen={setShowConfirmDelete} 
                    title={titleDelete}
                    text={textDelete}
                    handleAnswer={handleConfirmDelete}
                    fullScreen={fullScreen}
                />
            </Suspense>
        }
    	<div className="w-full h-full">
    		{render}    		
    		<div className='noprint'>	
	    		<div className="flex w-full mb-2 max-md:grid max-md:grid-cols-12 items-center"> 

	    			<div className="w-full max-md:col-span-12 max-md:text-center">
		          		<Input	                    
		                    name="search"
		                    type="text"
		                    value={searchText}	                    
		                    placeholder={t('filter.placeholder')}
		                    autoComplete="search"
		                    onChange={handleSearchInput}
		                    error=''
		        			handleKeyDown={handleQuickSearchKeyDown}
		                />
		            </div>
		            <div className="ml-2 max-md:ml-0 max-md:my-1 max-md:col-span-12 max-md:text-center flex justify-center items-center">
		            	<div className='mr-1'>
			          		<Button                     
			                    onClick={handleSearch}
			                    //text={t('filter.button.submit')}
			                    type='filter'
			                    icon={<FilterIcon/>}
			                />
			            </div>
			            <div>
			                <Button    
			                    onClick={removeFilters}			                    
			                    disabled={!filtersApplied}			                    
			                    type='reset'
			                    icon={<FilterOffIcon/>}
			                />
			            </div>
		            </div>
		            {/*
		            <div className="ml-2">
		          		<Button                     
		                    onClick={handleSearchClear}
		                    text={t('filter.button.reset')}
		                    type='reset'
		                />
		            </div>
		            */}
	          	</div>
	          	{/*
	          	<div className="flex justify-center items-center w-full px-1 py-1 my-1"> 
	          		<div className='mx-1'>
		        		<Button
		        			onClick={removeFilters}
		        			text={t('filters.remove')}
		        			type="filter"
		        			variant="contained"
		        			disabled={!filtersApplied}
		        		/>
		        	</div>
		        </div>	       
		        */}		        
	          	<TableButtons 
	          		className='mt-8'
	          		t={t}
	          		api={api}
	          		apiUrl={apiUrl}
	          		table={table}
	          		user={user}
	          		language={language}
	          		token={token}
	          		handleLogin={handleLogin}
	          		sendMessage={sendMessage}	          		
	          		editable={editable}
	          		enableAdd={enableAdd}
	          		modal={modal}
	          		enableEdit={enableEdit}
	          		addDisabled={addDisabled}
	          		savedEnabled={savedEnabled}
	          		editDisabled={editDisabled}
					deleteDisabled={deleteDisabled}
					anchorEl={anchorEl}
					setAnchorEl={setAnchorEl}
					handleButtonShare={handleButtonShare}
					handleButtonExport={handleButtonExport}
					handleButtonAdd={handleButtonAdd}
					handleButtonEdit={handleButtonEdit}
					handleButtonDelete={handleButtonDelete}
					handleButtonRefresh={handleRefresh}
					handleButtonConfig={handleButtonConfig}
					handleButtonFullscreen={handleButtonFullscreen}
					shareDisabled={shareDisabled}
					enableDelete={enableDelete}
					fullScreen={fullScreen}
	          	/>
          	</div>          	
          	<div id="table-grid" className={headerFixed ? 'h-full pb-4' : ''}></div>
          	{
          		numRenderedNodes > 10 &&
	          	<div className='noprint'>
	          		<TableButtons 
	          			className='pb-2'
		          		t={t}	   
		          		api={api}
		          		apiUrl={apiUrl}
		          		table={table}   
		          		user={user}
	          			language={language}
	          			token={token}
	          			handleLogin={handleLogin}
	          			sendMessage={sendMessage}    		
		          		editable={editable}
		          		enableAdd={enableAdd}
		          		modal={modal}
		          		enableEdit={enableEdit}
		          		addDisabled={addDisabled}
		          		savedEnabled={savedEnabled}
		          		editDisabled={editDisabled}
						deleteDisabled={deleteDisabled}
						anchorEl={anchorEl}
						setAnchorEl={setAnchorEl}
						handleButtonShare={handleButtonShare}
						handleButtonExport={handleButtonExport}
						handleButtonAdd={handleButtonAdd}
						handleButtonEdit={handleButtonEdit}
						handleButtonDelete={handleButtonDelete}
						handleButtonRefresh={handleRefresh}
						handleButtonConfig={handleButtonConfig}
						handleButtonFullscreen={handleButtonFullscreen}
						shareDisabled={shareDisabled}
						enableDelete={enableDelete}
						fullScreen={fullScreen}
		          	/>
	          	</div>  
	        }
	    </div>
	    </>
    );

}